"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledLogoImage = exports.StyledLabel = exports.StyledImageWrapper = exports.StyledBrandCard = exports.StyledBackgroundImage = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _picture = require("../../fuse-picture/src/picture");
var _typography = require("../../fuse-typography-element/src/typography");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
var StyledBrandCard = exports.StyledBrandCard = _styledComponents["default"].a.attrs({
  className: 'fuse-brand-card'
}).withConfig({
  displayName: "styled-brand-card__StyledBrandCard",
  componentId: "sc-mu7gpc-0"
})(["cursor:pointer;display:flex;flex-direction:column;gap:var(--spacing-global-space4);justify-content:flex-start;outline-offset:calc(-(var(--spacing-global-space1)));padding:var(--spacing-global-space1);text-decoration:none;&:focus-visible{outline:var(--border-width-s) solid var(--color-functional-focus);}&:focus:not(:focus-visible){outline:none;}", ";"], function () {
  var textDecorationUnderline = function textDecorationUnderline(colour) {
    return "\n\t\t\ttext-decoration-line: underline;\n\t\t\ttext-decoration-color: ".concat(colour, ";\n\t\t\ttext-decoration-style: solid;\n\t\t\ttext-decoration-thickness: 1px;\n\t\t");
  };
  return "\n\t\t\t&:hover .fuse-brand-card__label,\n\t\t\t&:focus .fuse-brand-card__label {\n\t\t\t\tcolor: var(--color-brand-dark);\n\t\t\t\t".concat(textDecorationUnderline("var(--color-brand-dark)"), "\n\t\t\t}\n\n\t\t\t&:active .fuse-brand-card__label {\n\t\t\t\tcolor: var(--color-global-black);\n\t\t\t\t").concat(textDecorationUnderline("var(--color-global-black)"), "\n\t\t\t}\n\t\t");
});
var StyledImageWrapper = exports.StyledImageWrapper = _styledComponents["default"].div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'isLogoOnly';
  }
}).attrs({
  className: 'fuse-brand-card__image-wrapper',
  'data-testid': 'fuse-brand-card-image-wrapper-test-id'
}).withConfig({
  displayName: "styled-brand-card__StyledImageWrapper",
  componentId: "sc-mu7gpc-1"
})(["position:relative;text-align:center;width:100%;", ""], function (_ref) {
  var isLogoOnly = _ref.isLogoOnly;
  return isLogoOnly ? "\n\t\t\t\talign-items: center;\n\t\t\t\tdisplay: flex;\n\t" : "";
});
var StyledBackgroundImage = exports.StyledBackgroundImage = (0, _styledComponents["default"])(_picture.Picture).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'imageSrc';
  }
}).attrs({
  className: 'fuse-brand-card__image-background'
}).withConfig({
  displayName: "styled-brand-card__StyledBackgroundImage",
  componentId: "sc-mu7gpc-2"
})(["display:flex;margin:0;& .fuse-picture__img{aspect-ratio:3/4;object-fit:cover;width:100%;}"]);
var StyledLogoImage = exports.StyledLogoImage = (0, _styledComponents["default"])(_picture.Picture).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['imageSrc', 'isLogoOnly'].includes(prop);
  }
}).attrs({
  className: 'fuse-brand-card__image-logo'
}).withConfig({
  displayName: "styled-brand-card__StyledLogoImage",
  componentId: "sc-mu7gpc-3"
})(["display:flex;justify-content:center;left:50%;margin:0;position:absolute;transform:translate(-50%,-50%);top:50%;width:80%;& .fuse-picture__img{aspect-ratio:16/9;object-fit:scale-down;width:100%;}", ""], function (_ref2) {
  var isLogoOnly = _ref2.isLogoOnly;
  return isLogoOnly ? "\n\t\t\t\tposition: static;\n\t\t\t\ttransform: unset;\n\t\t\t\twidth: 100%;\n\t\t\t" : "\n\t\t\t";
});
var StyledLabel = exports.StyledLabel = (0, _styledComponents["default"])(_typography.TypographyComponent).withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'isLogoOnly';
  }
}).attrs({
  className: 'fuse-brand-card__label',
  'data-testid': 'fuse-brand-card-label-test-id',
  size: '1',
  type: 'paragraph'
}).withConfig({
  displayName: "styled-brand-card__StyledLabel",
  componentId: "sc-mu7gpc-4"
})(["", " color:var(--color-global-grey1000);overflow:hidden;margin-bottom:0;"], function (_ref3) {
  var isLogoOnly = _ref3.isLogoOnly;
  return "\n\t\ttext-align: ".concat(isLogoOnly ? 'center' : 'left', ";\n\t");
});